import * as yup from 'yup';

export default yup.object({
  message: yup.string().min(1, 'Type a valid message').required('Required.')
});
